import BeachStreet from './assets/images/image1.png';
import BuffaloGrazing from './assets/images/image2.png';
import CaliforniaCoast from './assets/images/image3.png';
import Clownfish from './assets/images/image4.png';
import DeerFamily from './assets/images/image5.png';
import HollywoodPalms from './assets/images/image6.png';
import HouseInterior from './assets/images/image7.png';
import Panda from './assets/images/image8.png';
import Penguins from './assets/images/image9.png';
import SnowyMountainLake from './assets/images/image10.png';
import VolkswagenBug from './assets/images/image11.png';
import WhaleJumping from './assets/images/image12.png';
import randomize from './utils/randomize';

export const imageList = randomize([
  BeachStreet,
  BuffaloGrazing,
  CaliforniaCoast,
  Clownfish,
  HollywoodPalms,
  Panda,
  SnowyMountainLake,
  VolkswagenBug,
  Penguins,
  WhaleJumping,
  HouseInterior,
  DeerFamily,
]);

export default imageList;
